import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { ApplicationState } from '@/state/root.models'

import { PersonalizationEngineHeadPropsType } from '@/state/personalization-engine/models'
import { usePersonalizationEngineActions } from './use-personalization-engine-actions.hook'
import useTableSort from '@/hooks/table/use-table-sort.hook'
import { TransactionTypePayment } from '@/enums'

export const usePersonalizationEngineTable = () => {
  const { t } = useTranslation()

  const { filters, favoriteGames, isLoadingFavoriteGames, pagination } =
    useSelector(
      ({ personalizationEngine }: ApplicationState) => personalizationEngine,
    )

  const { getFavoriteGames, setPersonalizationEngineFilters } =
    usePersonalizationEngineActions()

  let headCells: PersonalizationEngineHeadPropsType[] = [
    { id: 'position', label: t('labels.position'), width: 150 },
    { id: 'name', label: t('labels.game'), width: 150 },
    { id: 'game_id', label: t('personalizationEngine.gameId'), width: 150 },
  ]

  if (!filters.transactionTypePayment) {
    headCells = [
      ...headCells,
      { id: 'amount', label: t('labels.amount'), width: 150 },
      { id: 'percentage', label: t('labels.percentage'), width: 400 },
    ]
  } else if (
    filters.transactionTypePayment === `${TransactionTypePayment.REAL_MONEY}`
  ) {
    headCells = [
      ...headCells,
      { id: 'amount_real_money', label: t('labels.amount'), width: 150 },
      {
        id: 'percentage_real_money',
        label: t('labels.percentage'),
        width: 400,
      },
    ]
  } else {
    headCells = [
      ...headCells,
      { id: 'amount_bonus_money', label: t('labels.amount'), width: 150 },
      {
        id: 'percentage_bonus_money',
        label: t('labels.percentage'),
        width: 400,
      },
    ]
  }

  const formattedPersonalizationEngine =
    favoriteGames?.map((pEngine, index) => {
      return {
        ...pEngine,
        position: index + 1,
        amount: Number(pEngine.amount),
        amount_bonus_money: Number(pEngine.amount_bonus_money),
        amount_real_money: Number(pEngine.amount_real_money),
      }
    }) || []

  const sortedInitialState = 'position'

  const { sortedRows, createSortHandler, order, orderBy } = useTableSort<
    any,
    keyof any
  >(formattedPersonalizationEngine, sortedInitialState, 'asc')

  const handleChangePage = (newPage: number) => {
    getFavoriteGames({
      ...filters,
      page: newPage,
    })
  }

  const handleChangeLimit = (newLimit: number) => {
    if (Math.ceil(pagination.total / newLimit) < (filters.page || 1)) {
      setPersonalizationEngineFilters({
        ...filters,
        limit: newLimit,
        page: 1,
      })
      getFavoriteGames({
        ...filters,
        limit: newLimit,
        page: 1,
      })
    } else {
      setPersonalizationEngineFilters({
        ...filters,
        limit: newLimit,
      })
      getFavoriteGames({
        ...filters,
        limit: newLimit,
      })
    }
  }

  return {
    createSortHandler,
    handleChangePage,
    handleChangeLimit,
    headCells,
    order,
    orderBy,
    sortedRows,
    isLoadingFavoriteGames,
    pagination,
  }
}
